module.exports = __webpack_public_path__ + "static/media/m1.c0fc99e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m1.mp4
// module id = nfQo
// module chunks = 1